import { render, staticRenderFns } from "./Workout.vue?vue&type=template&id=a20f631c&"
import script from "./Workout.vue?vue&type=script&lang=js&"
export * from "./Workout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports